"use client";

import React, { Suspense, useEffect, useState } from "react";
import MobileDownloadAppCTA from "./components/MobileDownloadAppCTA";
import DesktopAndTabletDownloadAppCTA from "./components/FloatingAppDownload";

export function FloatingAppDownload({
  desktopTop,
  mobileThreshold = -10
}: {
  desktopTop?: boolean;
  mobileThreshold?: number;
}) {
  const [bannersHeight, setBannersHeight] = useState(0);
  const [showMobileDownload, setShowMobileDownload] = useState(false);

  // Track banner height to position desktop version properly
  useEffect(() => {
    const checkBanners = () => {
      const bannersElement = document.getElementById("global-banners");
      if (bannersElement) {
        const height = bannersElement.getBoundingClientRect().height;
        setBannersHeight(height);
      } else {
        setBannersHeight(0);
      }
    };

    checkBanners();
    const observer = new MutationObserver(checkBanners);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  // Track scroll for mobile
  useEffect(() => {
    const scrollThreshold =
      typeof mobileThreshold === "number" ? mobileThreshold : 0;

    const onScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      setShowMobileDownload(scrollY > scrollThreshold);
    };

    onScroll(); // Run once immediately
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [mobileThreshold]);

  return (
    <React.Fragment>
      {/* Desktop/tablet version (at top if desktopTop=true, at bottom otherwise) */}
      <div
        className="tablet:flex tablet:h-[73px] tablet:p-0 tablet:right-[25px] tablet:w-[240px] fixed z-[50] hidden"
        style={
          desktopTop
            ? { top: bannersHeight > 0 ? `${80 + bannersHeight}px` : "80px" }
            : { bottom: "50px" }
        }
      >
        <div className="w-full items-center justify-end pr-8">
          <DesktopAndTabletDownloadAppCTA />
        </div>
      </div>

      {/* Mobile version */}
      <div
        className={`tablet:hidden fixed right-0 bottom-5 left-0 z-[50] block w-full ${!showMobileDownload ? "pointer-events-none opacity-0" : ""}`}
      >
        <div className="flex w-full items-center justify-center">
          <Suspense fallback={null}>
            <MobileDownloadAppCTA />
          </Suspense>
        </div>
      </div>
    </React.Fragment>
  );
}
